import React from "react";
import { Link } from "react-router-dom";

export default function FaqList({ items, numbered = true, offset = 0 }) {
  return (
    <div className="ro-faq-list">
      {items.map((f, i) => (
        <details className="ro-faq" key={f.q}>
          <summary>
            {numbered && <span className="ro-faq__num">{i + 1 + offset}</span>}
            <span className="ro-faq__q">{f.q}</span>
            <span className="ro-faq__icon" aria-hidden="true" />
          </summary>
          <div className="ro-faq__a">
            <p>{f.a}</p>
            {f.link && (
              <p>
                <Link to={f.link.to}>{f.link.label}</Link>
              </p>
            )}
          </div>
        </details>
      ))}
    </div>
  );
}
